// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"729":"266d23c0","746":"266d23c0"}[chunkId] + ".chunk.css";
};